let PROD_URL = 'https://wn5xj27b1i.execute-api.eu-central-1.amazonaws.com/dev'
// let DEV_URL = 'https://c538-109-134-50-209.ngrok.io'
exports.SERVER_URL = PROD_URL



// WEBPACK FOOTER //
// ./src/server.js